import { render } from "./Postmark.vue?vue&type=template&id=4d2f0016"
import script from "./Postmark.vue?vue&type=script&lang=js"
export * from "./Postmark.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__